import { Modal, Paper, Slide } from '@material-ui/core'
import ReactJson from 'react-json-view'

import useStyles from './styles/MonitoringFormViewMoreInfoModal.styles'

interface MonitoringFormViewMoreInfoModalProps {
  isOpen: boolean
  onClose: () => void
  requestView: Object
}
const MonitoringFormViewMoreInfoModal: React.FC<
  MonitoringFormViewMoreInfoModalProps
> = ({ isOpen, onClose, requestView }) => {
  const classes = useStyles()

  return (
    <Modal
      dir={'left'}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          <ReactJson src={requestView} displayObjectSize />
        </Paper>
      </Slide>
    </Modal>
  )
}
export default MonitoringFormViewMoreInfoModal
